<template>
    <FeaturesPageFeaturePanel icon="bw1mapper" :title="$t('pages.features.mapperCard.title')"
                              :desc="$t('pages.features.mapperCard.desc')">
        <ul class="mapperFeaturesList">
            <li v-for="(i,index) in $t('pages.features.mapperCard.featuresList')"
                :key="index">{{i}}
            </li>
        </ul>
        <div class="gallery-container">
            <MapperScreenshotGallery/>
        </div>
        <h2>
            {{$t('pages.features.mapperCard.typicalInstallations')}}
        </h2>
        <div class="gallery-container1">
            <MapperInstallationsGallery/>
        </div>

    </FeaturesPageFeaturePanel>

</template>

<script>
    import FeaturesPageFeaturePanel from "./toolkit/FeaturesPageFeaturePanel";
    import MapperScreenshotGallery from "./toolkit/MapperScreenshotGallery";
    import MapperInstallationsGallery from "./toolkit/MapperInstallationsGallery"

    export default {
        name: "MapperFeature",
        components: {FeaturesPageFeaturePanel, MapperScreenshotGallery, MapperInstallationsGallery}
    }
</script>

<style scoped lang="scss">
    @import "../../../theme/theme";

    ul > li {
        font-size: 0.9em;
        margin-bottom: 0.5em;
        text-align: justify;
        margin-right: 1em;
    }

    .gallery-container {
        display: grid;
        justify-items: center;
        padding-right: 1rem;
        margin-top: 1rem;
    }
    .gallery-container1 {
        display: grid;
        padding-right: 1rem;
        margin-top: 1rem;
    }


    @media (max-width: 40rem) {
        .inst-explane-container {
            grid-template-columns: 1fr 1fr;
        }
    }

    @media (min-width: 40rem) and (max-width: 60rem) {
        .inst-explane-container {
            grid-template-columns: repeat(3, minmax(9rem, 11rem));
        }
    }

    @media (min-width: 60rem) {
        .inst-explane-container {
            grid-template-columns: repeat(6, minmax(8rem, 10rem));
        }
    }

    h2 {
        margin-top: 1rem;
        font-weight: 300;
    }
</style>